import type { Workflow, WorkflowVisibility } from "@/stores/workflowsStore";

export const DEFAULT_WORKFLOW_VISIBILITY: WorkflowVisibility = "private";

export function resolveWorkflowVisibility(visibility?: WorkflowVisibility): WorkflowVisibility {
  return visibility ?? DEFAULT_WORKFLOW_VISIBILITY;
}

export function isWorkflowOwnedByUser(
  workflow: Pick<Workflow, "ownerUserId" | "createdBy">,
  userId?: string | null,
): boolean {
  if (!userId) return false;
  return workflow.ownerUserId ? workflow.ownerUserId === userId : workflow.createdBy === userId;
}

export function isWorkflowOrgVisible(visibility?: WorkflowVisibility): boolean {
  const resolved = resolveWorkflowVisibility(visibility);
  return resolved === "org" || resolved === "public" || resolved === "public_view" || resolved === "public_execute";
}

export function isWorkflowPublic(visibility?: WorkflowVisibility): boolean {
  const resolved = resolveWorkflowVisibility(visibility);
  return resolved === "public" || resolved === "public_view" || resolved === "public_execute";
}

export function getWorkflowVisibilityLabel(
  visibility: WorkflowVisibility | undefined,
  options?: { format?: "short" | "long" },
): string {
  const format = options?.format ?? "long";
  const resolved = resolveWorkflowVisibility(visibility);

  if (format === "short") {
    switch (resolved) {
      case "private":
        return "Private";
      case "org":
        return "Shared";
      case "public":
      case "public_view":
        return "Anyone can view";
      case "public_execute":
        return "Anyone can view and execute";
    }
  }

  switch (resolved) {
    case "private":
      return "Private";
    case "org":
      return "Visible to Org";
    case "public":
    case "public_view":
      return "Public View";
    case "public_execute":
      return "Public Execute";
  }
}
